import moment from 'moment';
import { createTeamApi, getLogIn, getUserApi, getUserProgramEnrollmentsApi, initializeChannel, setupCommunityApi } from '../../api';
import { ITeamRegForm, ILoginForm, ISelfServiceSetupForm } from '../../types/auth';
import { logger, format } from '../../datadogLogger';
import { Mixpanel } from '../../util/mixpanel';
import toastr from 'toastr';
import { setActivePhaseNumber, getUserProgramEnrollmentData } from './programEnrollmentAction';
import { getProgramById, getEnrolledChannels } from './programAction';
import { CHANGE_STATUS, GET_USER_ERROR, GET_USER_LOADER, GET_USER_SUCCESS, LOGIN_ERR, LOGIN_LOADER, LOGIN_SUCCESS, UPDATE_PROFILE } from '../../types';

// sign up team action
export const createTeam = (data: ITeamRegForm) => {
  return async (dispatch: any) => {
    try {
      const res = await createTeamApi(data);
      if (res.data.user) {
        localStorage.setItem('user', res.data.user);
        //await initializeChannel(res.data.user)
      }
      if (res.data.team) localStorage.setItem('team', res.data.team);
      if (res.data.token) localStorage.setItem('token', res.data.token);
      if (res.data.refreshToken) localStorage.setItem('refreshToken', res.data.refreshToken);
      const timeDelta = moment().diff(moment(res.timestamp), 'seconds');
      localStorage.setItem('timeDelta', timeDelta.toString());
      toastr.success(res.message)
      const userData = await getUserApi(res.data.user);
      localStorage.setItem('authInfo', JSON.stringify(userData?.data));
      const userEnrollment: any = await getUserProgramEnrollmentsApi(userData?.data?._id);
      if (userEnrollment && userEnrollment?.length > 0) {
        const activeEnrollment = userEnrollment[0];
        localStorage.setItem("activeProgramEnrollment", JSON.stringify(activeEnrollment));
        const programId = activeEnrollment?.programId;
        const communityIdentifier = activeEnrollment?.communityIdentifier;
        const userId = userData?.data?._id;

        if (programId) {
          dispatch(getProgramById(programId));
          if (userId) {
            dispatch(getUserProgramEnrollmentData(programId, userId));
            if (communityIdentifier) {
              dispatch(getEnrolledChannels(programId, userId, communityIdentifier));
            }
          }
        }
      }
      dispatch(loginSuccess(res, userData));
      dispatch(loginLoader(false));
      logger.info(format('Team account Register'), { ...userData.data });
      Mixpanel.identify(userData.data._id);
      Mixpanel.people.set(userData.data);
      const phaseNumber = userEnrollment[0]?.status?.activeProgramPhase?.phaseNumber;
      if(phaseNumber > 0 && phaseNumber <= 2) {
        dispatch(setActivePhaseNumber(phaseNumber));
        return { success: true, data: res.data,userData:userData };      }
    } catch (error) {
      logger.error(format('Team account register failed.'), error);
      toastr.error(error.response?.data.message)
    }
  }
}

// self-service community setup action
export const setupCommunity = (data: ISelfServiceSetupForm) => {
  return async (dispatch: any) => {
    try {
      const res = await setupCommunityApi(data);
      if (res.data.user) localStorage.setItem('user', res.data.user);
      if (res.data.token) localStorage.setItem('token', res.data.token);
      if (res.data.refreshToken) localStorage.setItem('refreshToken', res.data.refreshToken);
      const timeDelta = moment().diff(moment(res.timestamp), 'seconds');
      localStorage.setItem('timeDelta', timeDelta.toString());
      toastr.success(res.message);
      const userData = await getUserApi(res.data.user);
      localStorage.setItem('authInfo', JSON.stringify(userData?.data));
      const userEnrollment: any = await getUserProgramEnrollmentsApi(userData?.data?._id);
      if (userEnrollment && userEnrollment?.length > 0) {
        const activeEnrollment = userEnrollment[0];
        localStorage.setItem('activeProgramEnrollment', JSON.stringify(activeEnrollment));
        const programId = activeEnrollment?.programId;
        const communityIdentifier = activeEnrollment?.communityIdentifier;
        const userId = userData?.data?._id;
        if (programId) {
          dispatch(getProgramById(programId));
          if (userId) {
            dispatch(getUserProgramEnrollmentData(programId, userId));
            if (communityIdentifier) {
              dispatch(getEnrolledChannels(programId, userId, communityIdentifier));
            }
          }
        }
      }
      dispatch(loginSuccess(res, userData));
      dispatch(loginLoader(false));
      logger.info(format('Self-service community setup'), { ...userData.data });
      Mixpanel.identify(userData.data._id);
      Mixpanel.people.set(userData.data);
      return { success: true, data: res.data, userData };
    } catch (error) {
      logger.error(format('Self-service community setup failed.'), error);
      toastr.error(error.response?.data?.message || 'Setup failed. Please try again.');
      return { success: false, error: error.message };
    }
  };
};

// log in user action
export const startLogin = (authData: ILoginForm) => {
  return async (dispatch: any) => {
    try {
      dispatch(loginLoader(true));
      const res: any = await getLogIn(authData);
      if (res.data.user) {
        localStorage.setItem('user', res.data.user);
        //await initializeChannel(res.data.user)
      }
      if (res.data.team) localStorage.setItem('team', res.data.team);
      if (res.data.token) localStorage.setItem('token', res.data.token);
      if (res.data.refreshToken) localStorage.setItem('refreshToken', res.data.refreshToken);
      const timeDelta = moment().diff(moment(res.timestamp), 'seconds');
      localStorage.setItem('timeDelta', timeDelta.toString());
      const userData = await getUserApi(res.data.user);
      localStorage.setItem('authInfo', JSON.stringify(userData?.data));
      const userEnrollment: any = await getUserProgramEnrollmentsApi(userData?.data?._id);
      if (userEnrollment && userEnrollment?.length > 0) {
          const activeEnrollment = userEnrollment[0];
          localStorage.setItem("activeProgramEnrollment", JSON.stringify(activeEnrollment));
          const programId = activeEnrollment?.programId;
          const communityIdentifier = activeEnrollment?.communityIdentifier;
          const userId = userData?.data?._id;

          if (programId) {
            dispatch(getProgramById(programId));
            if (userId) {
              dispatch(getUserProgramEnrollmentData(programId, userId));
              if (communityIdentifier) {
                dispatch(getEnrolledChannels(programId, userId, communityIdentifier));
              }
            }
          }
      }
      else{
        toastr.error('User Not Enrolled');
        return { success: false, data: res.data,userData:userData,message:'User Not Enrolled' };      

      }
      toastr.success("Login Successfully");
      dispatch(loginSuccess(res, userData));
      dispatch(loginLoader(false));
      logger.info(format('User logged in'), { ...userData.data });
      Mixpanel.identify(userData.data._id);
      Mixpanel.people.set(userData.data);
      return { success: true, data: res.data,userData:userData };      
      //window.location.href = `/user/dashboard`;
      //const phaseNumber = userEnrollment[0]?.status?.activeProgramPhase?.phaseNumber;
      // if ((userData?.data?.type === UserType.admin || userData?.data?.type === UserType.teamAdmin) && userEnrollment?.length === 0) {
      //   window.location.href = '/admin/dashboard';
      // } else if (res?.data?.isFirstTimeLogin === 'false' || !res?.data?.isFirstTimeLogin) {
      //   window.location.href = '/set-password';
      // } else if (phaseNumber > 0 && phaseNumber < 2) {
      //   dispatch(setActivePhaseNumber(phaseNumber));
      //   window.location.href = `/onboarding/welcome`
      // }
      // else if (phaseNumber == 2) {
      //   dispatch(setActivePhaseNumber(phaseNumber));
      //   window.location.href = `/onboarding/phase/${phaseNumber}`
      // }
      // else if (phaseNumber >= 3){
      //   window.location.href = `/user/dashboard`;
      // }
    } catch (error) {
      logger.error(format('User logged in failed.'), error);
      dispatch(loginLoader(false));
      dispatch(loginError(error.message));
      return { success: false, error: error.message }
    }
  };
};

const loginLoader = (isLoading: boolean) => {
  return {
    type: LOGIN_LOADER,
    payload: isLoading,
  };
};
const loginSuccess = (tokens: any, userData: any) => {
  return {
    type: LOGIN_SUCCESS,
    payload: userData,
    tokens,
  };
};
const loginError = (payload: any) => {
  return {
    type: LOGIN_ERR,
    payload,
  };
};

// get user action

export const getUser = () => {
  return async (dispatch: any) => {
    try {
      const userId = localStorage.getItem('user');
      const token = localStorage.getItem('token');

      if (userId != null) {
        const res = await getUserApi(userId);

        localStorage.setItem('authInfo', JSON.stringify(res.data));
        dispatch(getUserSuccess(res, token));
        logger.info(format('Get user info'), { ...res.data });
      } else {
        dispatch(getUserError('No user Found'));
      }
      dispatch(getUserLoader(false));
    } catch (error) {
      logger.error(format('Failed to get User info'), error);
      dispatch(getUserLoader(false));
      dispatch(getUserError(error));
    }
  };
};

const getUserLoader = (isLoading: boolean) => {
  return {
    type: GET_USER_LOADER,
    payload: isLoading,
  };
};

const getUserSuccess = (user: any, token: string | null) => {
  return {
    type: GET_USER_SUCCESS,
    payload: user,
    token,
  };
};

const getUserError = (error: any) => {
  return {
    type: GET_USER_ERROR,
    payload: error,
  };
};

export const updateProfile = (user: any) => {
  return {
    type: UPDATE_PROFILE,
    payload: user
  }
}

// change user status
export const changeStatus = () => {
  return {
    type: CHANGE_STATUS,
  };
};

